import { render, staticRenderFns } from "./arrived.vue?vue&type=template&id=59c05b08&scoped=true&"
import script from "./arrived.vue?vue&type=script&lang=js&"
export * from "./arrived.vue?vue&type=script&lang=js&"
import style0 from "./arrived.vue?vue&type=style&index=0&id=59c05b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c05b08",
  null
  
)

export default component.exports